import { Badge, BadgeProps, Image, ColorProps } from '@chakra-ui/react';
import { useBreakpointValue } from '@ifixit/ui/hooks/use-media-query';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FaIcon } from '@ifixit/icons';
import { ReactNode, Ref } from 'react';
import { color } from '@ifixit/primitives';

type ThemeColors = keyof typeof color;

export type FlagBadgeStyle = {
   themeColor: ThemeColors;
   iconColor?: ColorProps['color'];
} & BadgeProps;

export function FlagBadge({
   ref,
   icon,
   iconColor,
   imageSrc,
   themeColor,
   children,
   ...badgeProps
}: {
   icon?: FontAwesomeIconProps['icon'];
   iconColor?: ColorProps['color'];
   imageSrc?: string;
   themeColor: ThemeColors;
   children?: ReactNode;
   ref?: Ref<HTMLDivElement>;
} & BadgeProps) {
   const fontSize = useBreakpointValue({ base: '13px', sm: '14px' });
   const iconSize = useBreakpointValue({ base: '16px', sm: '20px' });

   return (
      <Badge
         padding="4px 6px"
         lineHeight="18px"
         borderRadius="4px"
         fontSize={fontSize}
         display="flex"
         sx={{ '& svg': { paddingRight: '4px' } }}
         textTransform="none"
         fontWeight="medium"
         alignItems="center"
         background={`${themeColor}.100`}
         color={`${themeColor}.700`}
         borderWidth={1}
         borderColor={`${themeColor}.300`}
         tabIndex={0}
         ref={ref}
         {...badgeProps}
      >
         {icon && (
            <FaIcon
               fontSize={iconSize}
               icon={icon}
               color={iconColor ? iconColor : `${themeColor}.500`}
               fixedWidth={true}
            />
         )}
         {imageSrc && (
            <Image
               src={imageSrc}
               height={iconSize}
               width={iconSize}
               display="flex"
               alignSelf="center"
               paddingRight="4px"
            />
         )}
         {children}
      </Badge>
   );
}
